import { render, staticRenderFns } from "./form-empresa.vue?vue&type=template&id=64c95f3d&"
import script from "./form-empresa.vue?vue&type=script&lang=js&"
export * from "./form-empresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports